<template>
  <b-row>
    <b-col
      cols="12"
      class="mb-1"
    >
      <h3 class="mb-0">
        รายละเอียดการร้องทุกข์
      </h3>
    </b-col>

    <div v-for="value in complaintDetail" :key="value.description" class="col-12">
      <div class="mt-2">
        <h4 class="">
          {{value.description}}
        </h4>
          <b-row>

            <b-col
              v-for="(box, index) in value.tmMasterList"
              :key="index"
              cols="4"
              class="mt-1"
            >
              <b-form-checkbox
                :disabled="IsReadOnly"
                :key="index"
                v-model="box.checked"
                @change="checkboxChanged(box)"
              >
                {{ box.description }}
              </b-form-checkbox>
            </b-col>
            
          </b-row>
          <b-col cols="12">
            <hr>
          </b-col>
      </div>


    </div>

    

    <div v-for="value in complaintDetailMultiSelect" :key="value.description" class="col-12">
      <div class="mt-2">
        <h4 class="">
          {{value.description}}
        </h4>
          <b-row>
            <!--v-if="value.tmMasterList != null"  handle ตอนโหลดข้อมูล-->
            <b-col 
              v-if="value.tmMasterList != null" 
              cols="12"
              class="mt-1"
            >
            <multiselect
              :disabled="IsReadOnly"
              v-model="value.tmMasterListSelected"
              track-by="description"
              label="description"
              :options="value.tmMasterList"
              :multiple="true"
 
              >
            </multiselect>
            </b-col>
          </b-row>

          <b-col cols="12">
            <hr>
          </b-col>

      </div>


    </div>




  </b-row>

</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BForm,
  BButton,
  BCard,
  BFormTextarea,
  BFormCheckboxGroup,
  BFormCheckbox,
  BCardText,
} from 'bootstrap-vue'
import CustomSelectGroup from './CustomSelectGroup.vue'
import CustomRadioGroup from './CustomRadioGroup.vue'

import * as ComplaintAPI from '@/store/api/complaint/complaint.js'

import Multiselect from 'vue-multiselect'

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckboxGroup,
    BFormCheckbox,
    BCardText,
    BForm,
    BButton,
    BCard,
    BFormTextarea,
    CustomSelectGroup,
    CustomRadioGroup,
    ComplaintAPI,
    Multiselect
  },
  props: {
    IsReadOnly: Boolean,
    complaintDetail: {
      type: Array,
    },
    complaintDetailMultiSelect: {
      type: Array,
      default: []
    },
  },
  created() {
    // `this` points to the vm instance
    // console.log(`a is: ${this.a}`)
    // console.log('this complaintSubjectSelects', this.complaintSubjectSelects)
  },
  methods: {
    checkboxChanged(obj) {
      //console.log("checkboxChangedIn: ", obj)
      console.log("multiselectedChanged: ", this.complaintDetailMultiSelect)
      this.$emit('checkboxChanged', obj)
    },
    multiselectedChanged(obj){
     //console.log("multiselectedChanged: ", obj)
    },
    refreshPage(){//call from root
      this.$forceUpdate()
    }
  },
}

</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>